/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { httpService } from "../../../../services";
import { HTTP_METHOD } from "@nf/constants";
import { AppConfig } from "@nf/constants";
import { ITranslationListModel, ITranslationModel } from "../../../../models";

export class TranslationService {
  public getTranslationList = (): Promise<ITranslationListModel> =>
    httpService.request<ITranslationListModel>({
      axiosConfig: {
        timeout: 60000,
        headers: {
          Authorization: "",
        },
      },
      method: HTTP_METHOD.GET,
      url: `${AppConfig.TranslationsUrl}/api/translations`,
    });

  public getTranslation = (language: string): Promise<ITranslationModel> =>
    httpService.request<ITranslationModel>({
      axiosConfig: {
        timeout: 60000,
        headers: {
          Authorization: "",
        },
      },
      method: HTTP_METHOD.GET,
      url: `${AppConfig.TranslationsUrl}/${language}.json`,
    });
}
